import axios from "axios";

// Create an axios instance without a preset baseURL
const axiosClient = axios.create();

// Add a request interceptor that attaches the access token to every request
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosClient;